// src/pages/PaymentCancel.jsx
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} className="text-center">
          <h1>Payment canceled</h1>
          <p className="mt-3">
            Your PayPal checkout was canceled and you have not been charged.
          </p>
          <p>
            If it was a mistake or you changed your mind, you can try again
            anytime.
          </p>
          <div className="mt-4 d-flex gap-3 justify-content-center">
            <Button variant="primary" onClick={() => navigate("/pricing")}>
              Back to Plans
            </Button>
            <Button variant="outline-secondary" onClick={() => navigate("/")}>
              Go to Home
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentCancel;
